import { ApplicationFeatures } from "@bezoned/shared/features/subscriptions/application-features.constants.js";
import { FeatureGuard } from "@bezoned/shared/features/subscriptions/feature-guard.jsx";
import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import {
  ChatMultiple24Filled,
  PeopleQueue24Regular,
  PersonAddRegular,
} from "@fluentui/react-icons";

import { useChatUnreadStore } from "../../features/chat/chat-unread.store.js";
import { useSubscription } from "../../features/subscription/subscription.context.js";
import { useLayoutStore } from "../../store/layout.store.js";

export const RightSideMenu = () => {
  const chatVisible = useLayoutStore((state) => state.chatVisible);
  const hideModal = useLayoutStore((state) => state.hideModal);
  const modalVariant = useLayoutStore((state) => state.modalVariant);
  const personRosterVisible = useLayoutStore(
    (state) => state.personRosterVisible
  );
  const setChatVisible = useLayoutStore((state) => state.setChatVisible);
  const setModalVariant = useLayoutStore((state) => state.setModalVariant);
  const togglePersonRoster = useLayoutStore(
    (state) => state.togglePersonRoster
  );
  const { features } = useSubscription();
  const { officeUnread, tableUnread } = useChatUnreadStore();
  const commonButtonClassName =
    "flex flex-col items-center justify-center border-bzd-border-100 border-t px-4 pt-4 pb-4 font-semibold text-xs transition-colors ease-in-out select-none";
  const enabledButtonClassName =
    "hover:text-bzd-purple-500 text-bzd-gray-500 hover:cursor-pointer";
  const disabledClassName = "text-gray-400";
  const handleClick68 = useStableCallback(() => {
    const nextChatVisible = !chatVisible;
    setChatVisible(nextChatVisible, {
      persistPreference: !nextChatVisible,
    });
  });

  const handleClick82 = useStableCallback(() => {
    if (modalVariant) {
      hideModal();
      return;
    }

    setModalVariant("invite");
  });

  return (
    <section
      className="fixed top-25 right-5 z-10"
      data-blocks-hover="true"
      data-right-side-menu
    >
      <section className="center grid rounded-2xl bg-white shadow-md">
        <img
          alt="Logo"
          className="px-4 pt-4 pb-4"
          height={65}
          src="../images/bezoned-logo-mark.svg"
          width={65}
        />

        <FeatureGuard
          availableFeatures={features}
          feature={ApplicationFeatures.RosterWindow}
        >
          {(featureAvailable) => (
            <button
              aria-pressed={personRosterVisible}
              className={`${commonButtonClassName} ${featureAvailable ? enabledButtonClassName : disabledClassName}`}
              data-people-button
              disabled={!featureAvailable}
              onClick={togglePersonRoster}
              type="button"
            >
              <PeopleQueue24Regular
                className={`mb-1 text-2xl ${featureAvailable ? "" : disabledClassName}`}
              />
              People
            </button>
          )}
        </FeatureGuard>

        <button
          className={`${commonButtonClassName} ${enabledButtonClassName}`}
          onClick={handleClick68}
          type="button"
        >
          <div className="relative mb-1">
            <ChatMultiple24Filled />
            {Boolean(officeUnread || tableUnread) && (
              <span className="bg-bzd-red-500 absolute -top-1 -right-1 size-2 rounded-full" />
            )}
          </div>
          <span>Chat</span>
        </button>

        <button
          className={`${commonButtonClassName} ${enabledButtonClassName}`}
          onClick={handleClick82}
          type="button"
        >
          <PersonAddRegular className="mb-1 text-2xl" />
          Invite
        </button>
      </section>
    </section>
  );
};
